import { http } from "../../utils/config";

const reflectionAPI = {
  // Get reflections for Admin
  getReflections: (params = {}) => {
    return http.get("/api/v1/admin/reflections", { params });
  },

  // Get reflection by ID
  getReflectionById: (id) => {
    return http.get(`/api/v1/admin/reflections/${id}`);
  },

  // Reply to reflection (Admin)
  replyReflection: (id, replyData) => {
    return http.put(`/api/v1/admin/reflections/${id}/reply`, replyData);
  },

  // Delete reflection (Admin)
  deleteReflection: (id) => {
    return http.delete(`/api/v1/admin/reflections/${id}`);
  },

  // --- Resident APIs (Sanctum) ---
  getCustomerReflections: (params = {}) => {
    return http.get("/api/v1/customer/reflections", { params });
  },

  submitReflection: (formData) => {
    return http.post("/api/v1/customer/reflections", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

// Helper functions for handling API responses
export const reflectionHelpers = {
  // Extract data from API response
  extractReflectionData: (response) => {
    if (response.data && response.data.success) {
      return response.data.data;
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },

  // Extract paginated list from API response
  extractReflectionList: (response) => {
    if (response.data && response.data.success) {
      const data = response.data.data;
      return {
        reflections: data.data || [],
        pagination: {
          current: data.current_page,
          pageSize: data.per_page,
          total: data.total,
          from: data.from,
          to: data.to,
          lastPage: data.last_page,
        }
      };
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  }
};

// Error handling wrapper standard in project
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response;
    } catch (error) {
      console.error('API Error:', error);
      if (error.response) {
        const { status, data } = error.response;
        switch (status) {
          case 400: throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 401: throw new Error('Bạn cần đăng nhập để thực hiện thao tác này');
          case 403: throw new Error('Bạn không có quyền thực hiện thao tác này');
          case 404: throw new Error('Không tìm thấy dữ liệu yêu cầu');
          case 422: throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 500: throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default: throw new Error(data.message || 'Đã có lỗi xảy ra');
        }
      } else if (error.request) {
        throw new Error('Không thể kết nối đến server');
      } else {
        throw new Error(error.message || 'Đã có lỗi xảy ra');
      }
    }
  };
};

export const reflectionAPIWithErrorHandling = {
  getReflections: withErrorHandling(reflectionAPI.getReflections),
  getReflectionById: withErrorHandling(reflectionAPI.getReflectionById),
  replyReflection: withErrorHandling(reflectionAPI.replyReflection),
  deleteReflection: withErrorHandling(reflectionAPI.deleteReflection),
  
  // Resident
  getCustomerReflections: withErrorHandling(reflectionAPI.getCustomerReflections),
  submitReflection: withErrorHandling(reflectionAPI.submitReflection),
};

export default reflectionAPI;
